import { TDashboardComponent } from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import px from "MyDashboards/utils/px";
import React from "react";

const Render = ({ el }: { el: Element }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        fontSize: "30px",
        width: px(el.width),
        height: px(el.height),
        background: "rgba(0,100,255,0.1)",
      }}
    >
      {el.type === "text" ? "Text" : ""}
    </div>
  );
};

/**
 * This component renders a placeholder box in place of the actual element, can be used as default renderer
 */
const Placeholder: TDashboardComponent = {
  editorMode: "none",
  Edit: () => <div />,
  Render: Render,
};
export default Placeholder;
